export default "__VITE_ASSET__CXwrhoCW__"